<template>
  <div class="model-content">
    <div
      class="model_66"
      :class="
        posterList.lang == 'ug' || !posterList.lang ? 'model_ug' : 'model_zh'
      "
    >
      <img
        class="img-box"
        :src="posterList.lang == 'ug' || !posterList.lang ? url_ug : url_zh"
      />

      <div class="prize_img">
        <img :src="posterList.prize_image" alt="" />
      </div>

      <div class="prize_name">
        <div class="prize_name_text">{{ posterList.prize_name }}</div>
      </div>

      <div class="user-info">
        <div class="user-avatar">
          <div class="user-image">
            <img :src="posterList.avatar" alt="" />
          </div>
          <div class="user-name">
            <div class="user-name-text">{{ posterList.name }}</div>
            <div class="user-name-addr">{{ posterList.area }}</div>
          </div>
        </div>
        <div class="user-tel">{{ posterList.mobile }}</div>
        <div class="user-prize">
          <svg
            viewBox="0 0 19.0002 19"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="19.000244"
            height="19.000000"
            fill="none"
            customFrame="#000000"
          >
            <g id="组合 1485">
              <g id="coin copy 8">
                <circle
                  id="Oval Copy 2"
                  cx="9.97521877"
                  cy="9.97497463"
                  r="9.02502346"
                  fill="rgb(255,200,80)"
                />
                <circle
                  id="Oval"
                  cx="9.0254097"
                  cy="10.9250679"
                  r="7.1250186"
                  fill="rgb(221,153,43)"
                />
                <circle
                  id="Oval Copy 3"
                  cx="9.97462845"
                  cy="9.97511673"
                  r="7.1250186"
                  fill="rgb(255,220,100)"
                />
                <path
                  id="Shape"
                  d="M14.1794 14.6878C14.1154 14.6037 14.0155 14.5546 13.9088 14.5512C9.91278 14.4203 6.71376 11.1926 6.71376 7.22822C6.71376 6.16807 6.9451 5.16243 7.35821 4.25378C7.48895 3.96613 7.16236 3.68007 6.894 3.852C4.84156 5.16699 3.55432 7.54031 3.83912 10.188C4.16043 13.175 6.5394 15.6234 9.55711 16.0724C11.2228 16.3202 12.7841 15.9609 14.0735 15.1989C14.2554 15.0914 14.3067 14.8549 14.1794 14.6878L14.1794 14.6878Z"
                  fill="rgb(255,200,80)"
                  fill-rule="evenodd"
                />
                <path
                  id="moon-stars-path"
                  d="M5.11838 5.0893L3.80001 8.55002L2.48164 5.0893L0 4.27501L2.48164 3.46072L3.80001 0L5.11838 3.46072L7.60002 4.27501L5.11838 5.0893L5.11838 5.0893Z"
                  fill="rgb(255,255,255)"
                  fill-rule="evenodd"
                />
              </g>
              <path
                id=""
                d="M10.669 12.2176C10.669 12.3169 10.6315 12.4 10.5565 12.4668C10.4836 12.5337 10.3975 12.5671 10.2982 12.5671L9.5261 12.5671C9.42478 12.5671 9.33663 12.5337 9.26166 12.4668C9.18871 12.4 9.15223 12.3169 9.15223 12.2176C9.15223 12.1608 9.16034 12.0737 9.17655 11.9562L9.18871 11.6948L9.18871 10.8984C9.18871 10.0514 9.16945 9.43736 9.13095 9.05639C9.09448 8.67543 9.02862 8.41807 8.93338 8.28433C8.83814 8.15059 8.6821 8.08372 8.46528 8.08372C7.93436 8.08372 7.6608 8.51129 7.64458 9.36643L7.64458 10.4516L7.64458 10.488L7.64458 11.6948C7.64458 11.7941 7.65066 11.8964 7.66282 12.0018C7.67498 12.1051 7.68106 12.1811 7.68106 12.2297C7.68106 12.3311 7.64357 12.4131 7.56859 12.476C7.49564 12.5367 7.40851 12.5671 7.30719 12.5671L6.55033 12.5671C6.44901 12.5671 6.35883 12.5337 6.2798 12.4668C6.2028 12.4 6.1643 12.3169 6.1643 12.2176C6.1643 12.1527 6.1724 12.0707 6.18861 11.9714C6.20482 11.8701 6.21293 11.7779 6.21293 11.6948L6.21293 10.488C6.19672 9.60048 6.17544 8.97635 6.1491 8.61565C6.12478 8.25292 6.08831 7.91857 6.03967 7.61258C6.00522 7.37954 5.97989 7.19717 5.96368 7.06545C5.94747 6.89928 5.96773 6.76048 6.02447 6.64902C6.08324 6.53554 6.1876 6.47881 6.33755 6.47881C6.39632 6.47881 6.46724 6.49096 6.55033 6.51528L7.29503 6.72805C7.38622 6.76048 7.46525 6.81012 7.53212 6.87699C7.59899 6.94387 7.64053 7.01884 7.65674 7.10192C7.87357 6.91144 8.05189 6.78074 8.19171 6.70982C8.33356 6.63889 8.52911 6.60343 8.77836 6.60343C8.94452 6.60343 9.08131 6.61153 9.18871 6.62775C9.67099 6.68651 10.0611 6.95197 10.359 7.42412L10.3711 7.39981C10.6123 7.11814 10.8382 6.91347 11.0489 6.78581C11.2617 6.65612 11.5211 6.59127 11.8271 6.59127C11.894 6.59127 12.0105 6.59938 12.1766 6.61559C12.4664 6.64801 12.7207 6.7625 12.9396 6.95906C13.1605 7.1536 13.3287 7.38157 13.4442 7.64297C13.5617 7.90438 13.6205 8.1435 13.6205 8.36032L13.6205 10.1507C13.6205 10.6491 13.6387 10.9896 13.6752 11.172C13.7137 11.3543 13.7998 11.4455 13.9335 11.4455C14.0166 11.4455 14.1362 11.4131 14.2922 11.3483C14.3104 11.3381 14.3256 11.3381 14.3378 11.3483C14.35 11.3564 14.356 11.3685 14.356 11.3847C14.2973 11.8326 14.1808 12.1416 14.0065 12.3118C13.8322 12.482 13.5627 12.5671 13.1979 12.5671C12.9082 12.5671 12.665 12.4496 12.4684 12.2145C12.2739 11.9775 12.1766 11.7009 12.1766 11.3847L12.1766 9.92876C12.1766 9.45458 12.1574 9.08881 12.1189 8.83146C12.0824 8.57411 12.0125 8.38565 11.9092 8.26609C11.8058 8.14451 11.6538 8.08372 11.4532 8.08372C11.1959 8.08372 10.9963 8.20024 10.8544 8.43327C10.7146 8.66631 10.6406 9.00675 10.6325 9.45458L10.6325 11.6948C10.6325 11.7535 10.6406 11.8407 10.6568 11.9562L10.669 12.2176Z"
                fill="rgb(238,148,0)"
                fill-rule="nonzero"
              />
            </g>
          </svg>

          <span>{{ posterList.amount || 0 }}</span>
        </div>
      </div>

      <div
        class="user-qrcode"
        :class="posterList.lang == 'ug' ? 'qrcode-ug' : 'qrcode-zh'"
      >
        <img :src="posterList.user_qr_code" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "model_66",
  data() {
    return {
      posterList: {},
      url_ug: require("../../img/poster/model_ug_66.png"),
      url_zh: require("../../img/poster/model_zh_66.png"),
    };
  },
  created() {
    this.posterList = this.$route.query;
  },
};
</script>

<style scoped>
.model-content {
  width: 391px;
  height: 778px;
  position: relative;
  margin: auto;
  display: flex;
  justify-content: center;
}

.model_66 {
  width: 391px;
  height: 778px;
  position: relative;
}

.model_ug {
  direction: rtl;
}

.model_zh {
  direction: ltr;
}

.img-box {
  width: 100%;
  height: 100%;
}

.prize_img {
  position: absolute;
  top: 230px;
  left: 50%;
  transform: translateX(-50%);
  width: 260px;
  height: 280px;
}

.prize_img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.prize_name {
  position: absolute;
  width: 300px;
  height: 38px;
  top: 520px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border-radius: 20px;
}

.prize_name_text {
  font-size: 18px;
  color: #000000;
}

.user-info {
  position: absolute;
  width: 320px;
  height: 38px;
  top: 580px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 6px;
  color: #fff;
  font-size: 14px;
}

.user-info .user-avatar {
  display: flex;
  align-items: center;
}

.user-info .user-name {
  padding: 0px 8px;
}

.user-info .user-avatar .user-image {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
}

.user-info .user-avatar .user-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-info .user-tel {
  direction: ltr;
}

.user-name .user-name-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 80px;
}

.user-name .user-name-addr {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 80px;
}

.user-prize {
  direction: ltr;
  display: flex;
  align-items: center;
  column-gap: 4px;
}

.user-prize svg {
  margin-bottom: 2px;
}

.user-qrcode {
  position: absolute;
  height: 100px;
  width: 100px;
  border-radius: 10px;
  overflow: hidden;
}

.user-qrcode.qrcode-ug {
  bottom: 28px;
  right: 13px;
}

.user-qrcode.qrcode-zh {
  bottom: 18px;
  left: 21px;
}

.user-qrcode img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
